"use client";

import { ThemeProvider as NextThemesProvider, type ThemeProviderProps } from "next-themes";
import type { ComponentType, ReactNode } from "react";

const NextThemes = NextThemesProvider as unknown as ComponentType<
  ThemeProviderProps & { children: ReactNode }
>;

export function ThemeProvider(props: ThemeProviderProps & { children: ReactNode }) {
  return <NextThemes {...props} />;
}

export type { ThemeProviderProps };
